module.exports = __webpack_public_path__ + "static/media/AccountManagment.b8a99071.svg";